import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const scrollToTop = () => {
    if (!isHomePage) {
      window.location.href = "/";
      return;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false);
  };

  const scrollToSection = (sectionId: string) => {
    if (!isHomePage) {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  const navLinks = [
    { label: "About", sectionId: "about" },
    { label: "Coaching", sectionId: "services" },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-cream/95 backdrop-blur-sm border-b border-border">
      <nav className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between h-10">
          {/* Logo */}
          <button 
            onClick={scrollToTop}
            className="font-display text-xl md:text-2xl font-bold text-primary hover:text-accent transition-colors whitespace-nowrap"
          >
            Rebecca Ryell Travel
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.sectionId}
                onClick={() => scrollToSection(link.sectionId)}
                className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors whitespace-nowrap"
              >
                {link.label}
              </button>
            ))}
            <Link
              to="/field-notes"
              className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors whitespace-nowrap"
            >
              Field Notes
            </Link>
            <Link
              to="/travel-builds-resilience-in-children"
              className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors whitespace-nowrap"
            >
              Guides
            </Link>
            
            <Button 
              onClick={() => scrollToSection("hero")}
              className="bg-primary hover:bg-accent text-primary-foreground font-mono uppercase tracking-wider whitespace-nowrap ml-4"
            >
              Work With Me
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 text-foreground hover:text-accent transition-colors"
            aria-label="Toggle menu"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-border pt-4 animate-fade-in">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <button
                  key={link.sectionId}
                  onClick={() => scrollToSection(link.sectionId)}
                  className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors text-left"
                >
                  {link.label}
                </button>
              ))}
              <Link
                to="/field-notes"
                onClick={() => setIsOpen(false)}
                className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors"
              >
                Field Notes
              </Link>
              <Link
                to="/travel-builds-resilience-in-children"
                onClick={() => setIsOpen(false)}
                className="font-mono text-sm uppercase tracking-wider text-foreground hover:text-accent transition-colors"
              >
                Guides
              </Link>
              
              <Button 
                onClick={() => scrollToSection("hero")}
                className="bg-primary hover:bg-accent text-primary-foreground font-mono uppercase tracking-wider w-full"
              >
                Work With Me
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navigation;
